import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import { AddressModel } from '../address.model';
import { OrganisationJointCommittee, OrganisationJointCommitteeAdapter } from './organisation-joint-committee.model';


export interface Department{
  
  id:string;
  name:string;
  address:AddressModel;
  emailAddress:string;
  contact:string;
  phoneNumber:string;
  amountOfActiveEmployees:number;
  amountOfFullTimeEquivalentEmployees:number;
  committees:OrganisationJointCommittee[];
}


@Injectable({
  providedIn: 'root'
})

export class DepartmentAdapter implements Adapter<Department> {
  constructor(    private commiteeAdapter:OrganisationJointCommitteeAdapter,
    ){}
  adapt(item: any): Department {
    return {
      id: item.id,
      name:item.name??'',
      address:item.address,
      emailAddress:item.emailAddress??'',
      contact:item.contactPerson??'',
      phoneNumber:item.phoneNumber??'',
      amountOfActiveEmployees:item.amountOfActiveEmployees??0,
      amountOfFullTimeEquivalentEmployees:item.amountOfFullTimeEquivalentEmployees??0,
      committees:(item.jointCommittees??[]).map((c:any) => this.commiteeAdapter.adapt(c,true))
    } as Department
  }
}
